<ng-template #fieldTypeTemplate></ng-template>
<ng-container *ngIf="props.uploadType === 'default'">
  <ng-container *ngTemplateOutlet="default"></ng-container>
</ng-container>
<ng-container *ngIf="props.uploadType === 'dashboard'">
  <ng-container *ngTemplateOutlet="uppyDashboard"></ng-container>
</ng-container>
<ng-container *ngIf="props.uploadType === 'drag-drop'">
  <ng-container *ngTemplateOutlet="dragandDrop"></ng-container>
</ng-container>
<ng-container *ngIf="props.uploadType === 'upload-details'">
  <ng-container *ngTemplateOutlet="uploadDetails"></ng-container>
</ng-container>

<ng-template #uppyDashboard>
  <div class="field-file">
    <div class="inline-flex justify-start items-start gap-6 max-sm:flex-col">
      <!-- preview -->
      <div *ngIf="props.preview" class="preview rounded-md flex-none overflow-hidden"
        [ngClass]="props.previewResource !== 'avatar' ? 'h-40 w-72 max-sm:h-auto max-sm:min-h-32 max-sm:w-full' : 'h-[84px] w-[84px] min-w-[84px]'">
          <!-- Image Preview -->
          <ng-container *ngIf="props.previewType === 'image'">
            <ng-container *ngIf="!props?.previewUrl || !field.formControl.value">
              <ng-container *ngTemplateOutlet="noPreviewUI"></ng-container>
            </ng-container>
            <ng-container *ngIf="props?.previewUrl">
              <div class="overflow-hidden flex items-center justify-center" [ngClass]="props.previewResource === 'avatar' ? 'rounded-full w-full h-full' : 'rounded'">
                <!-- <img [src]="props.previewUrl" (error)="onImageError($event)" alt="Preview" class="max-w-full"/> -->
                <img [src]="sanitizeUrl(props.previewUrl)" (error)="onImageError($event)" alt="Preview" class="max-w-full"/>
              </div>
            </ng-container>
          </ng-container>
          <!-- File Preview -->
          <ng-container *ngIf="props.previewType === 'file'">
            <ng-container *ngIf="!props?.previewUrl || !field.formControl.value; else showPreviewFile">
              <ng-container *ngTemplateOutlet="noPreviewUI"></ng-container>
            </ng-container>
            <ng-template #showPreviewFile>
              <div class="overflow-hidden rounded">
                <img src="assets/images/image-placeholder.svg" class="m-auto h-11 w-11" alt="" />
              </div>
            </ng-template>
          </ng-container>
          <!-- Video Preview -->
          <ng-container *ngIf="props.previewType === 'video'">
            <ng-container *ngIf="{ status: processingStatus$ | async} as vm">
              <div class="rounded h-full relative">
                <ng-container *ngIf="vm.status ==='init'">
                  <ng-container *ngTemplateOutlet="noPreviewUI"></ng-container>
                </ng-container>
                <ng-container *ngIf="vm.status === 'upload-progress'">
                  <div class="h-full w-full flex mx-auto items-center justify-center rounded-xl bg-slate-300 animate-pulse flex-col min-h-32">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" class="w-6 h-6 text-amber-500">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.26562 23.408V5.27162C5.26562 5.27162 5.7429 3.33008 7.17472 3.33008C8.60653 3.33008 17.6747 3.36253 17.6747 3.36253V8.34335C17.6747 8.34335 18.9099 10.0444 19.5838 10.0444H23.402V18.8672C23.402 18.8672 18.0651 17.5051 16.8901 22.5823C16.4013 24.6928 17.3521 25.4899 17.6747 26.1819L7.17472 26.2716C7.17472 26.2716 5.26562 25.6531 5.26562 23.408Z" fill="transparent"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.4454 26.7494H7.17543C6.54256 26.7494 5.93547 26.4983 5.48778 26.0507C5.0401 25.603 4.78906 24.9959 4.78906 24.363C4.78906 20.0485 4.78906 9.58665 4.78906 5.27211C4.78906 4.63924 5.0401 4.03215 5.48778 3.58447C5.93547 3.13679 6.54256 2.88574 7.17543 2.88574H17.6754C17.8148 2.88574 17.9475 2.94683 18.0382 3.05279L23.7654 9.7346C23.8389 9.82051 23.88 9.93124 23.88 10.0448V18.7322C25.5791 19.6017 26.7436 21.3705 26.7436 23.4085C26.7436 26.3065 24.3916 28.6585 21.4936 28.6585C19.8652 28.6585 18.4085 27.9149 17.4454 26.7494ZM21.4936 19.113C23.8647 19.113 25.7891 21.0374 25.7891 23.4085C25.7891 25.7796 23.8647 27.7039 21.4936 27.7039C19.1225 27.7039 17.1982 25.7796 17.1982 23.4085C17.1982 21.0374 19.1225 19.113 21.4936 19.113ZM21.0163 22.6515L20.4808 23.187C20.2947 23.3732 19.9921 23.3732 19.806 23.187C19.6198 23.0009 19.6198 22.6983 19.806 22.5122L21.1557 21.1615C21.3428 20.9753 21.6444 20.9753 21.8315 21.1615L23.1812 22.5122C23.3674 22.6983 23.3674 23.0009 23.1812 23.187C22.9951 23.3732 22.6925 23.3732 22.5064 23.187L21.9709 22.6515V25.3176C21.9709 25.581 21.7571 25.7948 21.4936 25.7948C21.2302 25.7948 21.0163 25.581 21.0163 25.3176V22.6515ZM17.1982 3.84029H7.17543C6.79552 3.84029 6.43183 3.99111 6.16265 4.25933C5.89442 4.52851 5.74361 4.8922 5.74361 5.27211V24.363C5.74361 24.7429 5.89442 25.1066 6.16265 25.3758C6.43183 25.644 6.79552 25.7948 7.17543 25.7948H16.8173C16.4507 25.0789 16.2436 24.2676 16.2436 23.4085C16.2436 20.5105 18.5956 18.1585 21.4936 18.1585C21.99 18.1585 22.4701 18.2272 22.9254 18.3561V10.5221H19.5845C18.2663 10.5221 17.1982 9.45397 17.1982 8.13574V3.84029ZM9.08452 16.2494H19.5845C19.848 16.2494 20.0618 16.0356 20.0618 15.7721C20.0618 15.5087 19.848 15.2948 19.5845 15.2948H9.08452C8.82106 15.2948 8.60724 15.5087 8.60724 15.7721C8.60724 16.0356 8.82106 16.2494 9.08452 16.2494ZM9.08452 13.3857H19.5845C19.848 13.3857 20.0618 13.1719 20.0618 12.9085C20.0618 12.645 19.848 12.4312 19.5845 12.4312H9.08452C8.82106 12.4312 8.60724 12.645 8.60724 12.9085C8.60724 13.1719 8.82106 13.3857 9.08452 13.3857ZM9.08452 10.5221H13.8572C14.1207 10.5221 14.3345 10.3083 14.3345 10.0448C14.3345 9.78138 14.1207 9.56756 13.8572 9.56756H9.08452C8.82106 9.56756 8.60724 9.78138 8.60724 10.0448C8.60724 10.3083 8.82106 10.5221 9.08452 10.5221ZM18.1527 4.65356V8.13574C18.1527 8.92611 18.7942 9.56756 19.5845 9.56756H22.3651L18.1527 4.65356Z" fill="currentColor"/>
                    </svg>
                    <h3 class="text-lg text-slate-600" i18n>Uploading...</h3>
                  </div>
                </ng-container>
                <ng-container *ngIf="vm.status === 'upload-success'">
                  <div class="h-full w-full flex mx-auto items-center justify-center rounded-xl bg-slate-300 animate-pulse flex-col min-h-32">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-green-500 w-8 h-8">
                      <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                    </svg>
                    <h3 class="text-lg text-slate-600" i18n>File Uploaded</h3>
                  </div>
                </ng-container>
                <ng-container *ngIf="vm.status === 'processing'">
                  <div class="h-full w-full flex mx-auto items-center justify-center rounded-xl bg-slate-300 animate-pulse flex-col min-h-32">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 19" fill="currentColor" class="text-slate-600 w-8 h-8">
                      <path d="M12.9977 16.7H12.2987V14.426C12.2995 13.6453 12.1067 12.8766 11.7376 12.1886C11.3685 11.5007 10.8346 10.915 10.1837 10.484L8.69866 9.5L10.1837 8.516C10.8346 8.08498 11.3685 7.49929 11.7376 6.81135C12.1067 6.12342 12.2995 5.3547 12.2987 4.574V2.3H12.9977C13.2364 2.3 13.4653 2.20518 13.6341 2.0364C13.8028 1.86761 13.8977 1.63869 13.8977 1.4C13.8977 1.16131 13.8028 0.932387 13.6341 0.763604C13.4653 0.594821 13.2364 0.5 12.9977 0.5H0.997656C0.758961 0.5 0.530043 0.594821 0.36126 0.763604C0.192477 0.932387 0.0976563 1.16131 0.0976563 1.4C0.0976563 1.63869 0.192477 1.86761 0.36126 2.0364C0.530043 2.20518 0.758961 2.3 0.997656 2.3H1.84066V4.574C1.83931 5.3548 2.03186 6.12371 2.401 6.81174C2.77015 7.49976 3.30435 8.08537 3.95566 8.516L5.44066 9.5L3.95566 10.484C3.30712 10.9164 2.77586 11.5027 2.40939 12.1906C2.04292 12.8785 1.85267 13.6466 1.85566 14.426V16.7H0.997656C0.758961 16.7 0.530043 16.7948 0.36126 16.9636C0.192477 17.1324 0.0976563 17.3613 0.0976562 17.6C0.0976563 17.8387 0.192477 18.0676 0.36126 18.2364C0.530043 18.4052 0.758961 18.5 0.997656 18.5H12.9977C13.2364 18.5 13.4653 18.4052 13.6341 18.2364C13.8028 18.0676 13.8977 17.8387 13.8977 17.6C13.8977 17.3613 13.8028 17.1324 13.6341 16.9636C13.4653 16.7948 13.2364 16.7 12.9977 16.7ZM3.64066 14.426C3.64016 13.9426 3.75935 13.4666 3.98759 13.0405C4.21582 12.6144 4.546 12.2514 4.94866 11.984L7.06966 10.58L9.18766 11.984C9.59068 12.2513 9.9213 12.6142 10.15 13.0402C10.3788 13.4663 10.4986 13.9424 10.4987 14.426V16.7H3.64066V14.426Z"/>
                    </svg>
                    <h3 class="text-lg text-slate-600" i18n>Processing</h3>
                  </div>
                </ng-container>
                <ng-container *ngIf="vm.status === 'failed'">
                  <div class="tooltip-container h-full w-full flex mx-auto items-center justify-center rounded-xl bg-red-50 flex-col min-h-32 gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-red-500 w-8 h-8">
                      <path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
                    </svg>
                    <h3 class="text-lg text-red-500" i18n>Processing failed</h3>
                    <button class="btn btn-sm btn-outline-red h-auto" (click)="handleFileInfo('retry')">
                      <svg-icon src="@assets/images/icons/x-circle.svg" class="btn-icon"></svg-icon>
                      <span i18n>Retry</span>
                    </button>
                    <div class="ltr:right-0 rtl:left-0 tooltip-items before:ltr:right-1/2 before:rtl:left-1/2 !-top-[0px] rounded-md bg-slate-700 text-slate-400 text-sm p-3">
                      <p class="mb-0">{{props.processingStatus?.error}}</p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="vm.status === 'resume'">
                  <div class="tooltip-container h-full w-full flex mx-auto items-center justify-center rounded-xl bg-red-50 flex-col min-h-32 gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-slate-600 w-8 h-8">
                      <path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
                    </svg>
                    <h3 class="text-lg text-slate-600" i18n>Processing pending</h3>
                    <button class="btn btn-sm btn-outline-red h-auto" (click)="handleFileInfo('retry')">
                      <svg-icon src="@assets/images/icons/backward.svg" class="btn-icon ltr:hidden rtl:block"></svg-icon>
                      <svg-icon src="@assets/images/icons/backward.svg" class="btn-icon rotate-180 ltr:block rtl:hidden"></svg-icon>
                      <span i18n>Resume</span>
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="vm.status === 'completed' || vm.status ===  'complete'">
                  <app-formly-videoplayer [enableHotkey]="enableHotkey" [sources$]="sources$"></app-formly-videoplayer>
                </ng-container>
                <div *ngIf="vm.status === 'loading'" class="flex h-[264px] w-full items-center justify-center">
                  <svg
                    class="text-amber-500 m-auto h-12 w-12 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              </div>
            </ng-container>
          </ng-container>
      </div>
      <!-- end preview -->
      <div class="flex flex-col gap-4 mb-2">
        <formly-fileDashboardInfo [field]="field" (clickEvent)="handleFileInfo($event)"></formly-fileDashboardInfo>
      </div>
    </div>
  </div>
  <uppy-drag-drop #dashboardUploader [uppy]="uppy" class="hidden h-[0] w-[0]"></uppy-drag-drop>
  <uppy-status-bar [uppy]="uppy" [props]="uppyStatusBarOptions" class="relative z-[999]"></uppy-status-bar>
  <common-modal #uploadModal customClass="sm:w-full sm:max-w-2xl" [title]="props.label">
    <ng-container content>
      <div class="h-[380px] p-4">
        <uppy-dashboard
          #uppyDashboard
          [uppy]="uppy"
          [props]="uppyDashboardOptions"
          class="uppy-dashboard"
        ></uppy-dashboard>
      </div>
    </ng-container>
  </common-modal>
</ng-template>


<ng-template #dragandDrop>
  <div class="uppyUpload relative aspect-[7/4]" *ngIf="{uploads: uploads$ | async, lectureId: lectureId$ | async} as vm">
    <ng-container *ngIf="vm.uploads && vm.lectureId">
      <div class="bg-white bg-opacity-50 z-10 absolute w-full h-full cursor-not-allowed" *ngIf="props.disabled && vm.uploads![vm.lectureId!]?.status !== 'init'"></div>
      <uppy-drag-drop [uppy]="uppy" class="uppyUpload-dragdrop h-full" *ngIf="vm.uploads![vm.lectureId!]?.status === 'init'"></uppy-drag-drop>
      <div class="uppyUpload-dragdrop h-full justify-center" *ngIf="vm.uploads![vm.lectureId!]?.status !== 'init'">
        <formly-DragDropInfo
        [uploadState]="(state$ | async)!"
        (clickEvent)="handleFileInfo($event)"
        [fileStatus]="props.processingStatus"
        [sources$]="sources$"
        [enableHotkey]="enableHotkey"
        ></formly-DragDropInfo>
      </div>
    </ng-container>
  </div>
</ng-template>

<!--<ng-template #dragandDrop>
  <div class="uppyUpload relative">
    <div class="bg-white bg-opacity-50 z-10 absolute w-full h-full cursor-not-allowed" *ngIf="props.disabled && (!(state$ | async)?.viewState && (this.isLoading$ | async) === null)"></div>
    <uppy-drag-drop [uppy]="uppy" class="uppyUpload-dragdrop" *ngIf="!(state$ | async)?.viewState && (this.isLoading$ | async) === null"></uppy-drag-drop>
    <div class="uppyUpload-dragdrop" *ngIf="(state$ | async)?.viewState || (this.isLoading$ | async) !== null">
      <formly-DragDropInfo
        [uploadState]="(state$ | async)!"
        (clickEvent)="handleFileInfo($event)"
        [fileStatus]="props.processingStatus"
        [sources$]="sources$"
      ></formly-DragDropInfo>
    </div>
  </div>
</ng-template> -->

<ng-template #uploadDetails>
  <div class="relative" *ngIf="{uploads: uploads$ | async, lectureId: lectureId$ | async} as vm">
    <ng-container *ngIf="vm.uploads && vm.lectureId">
      <!-- {{vm.uploads![vm.lectureId!] | json}} -->
      <!-- uploader -->
      <div class="uppyUpload w-full aspect-[8/2]" *ngIf="vm.uploads![vm.lectureId!]?.status === 'init'">
        <uppy-drag-drop #dashboardUploader [uppy]="uppy" class="uppyUpload-dragdrop h-full w-full"></uppy-drag-drop>
      </div>
      <div class="flex items-center gap-4" *ngIf="vm.uploads![vm.lectureId!]?.status !== 'init'">

        <!-- Status upload-progress & uploading -->
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'upload-progress' || vm.uploads![vm.lectureId!]?.status === 'uploading'">
          <div class="relative w-44 aspect-[8/5] bg-green-50 rounded-lg flex items-center justify-center">
            <div class="text-slate-400">{{ vm.uploads![vm.lectureId!].progressPercent }}%</div>
          </div>
        </ng-container>
        <!-- Status upload-complete -->
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'upload-complete'">
          <div class="relative w-44 aspect-[8/5] bg-green-50 rounded-lg flex items-center justify-center">
            <svg-icon src="@assets/images/icons/check-circle-solid.svg" class="text-green-500 w-5"></svg-icon>
          </div>
        </ng-container>
        <!-- Status processing -->
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'processing'">
          <div class="relative w-44 aspect-[8/5] bg-green-50 rounded-lg flex items-center justify-center">
            <svg-icon src="@assets/images/icons/hourglass.svg" class="text-green-500 w-5"></svg-icon>
          </div>
        </ng-container>
        <!-- Status failed -->
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'failed'">
          <div class="relative w-44 aspect-[8/5] bg-red-50 rounded-lg flex items-center justify-center">
            <svg-icon src="@assets/images/icons/exclamation-triangle-solid.svg" class="text-red-500 w-5"></svg-icon>
          </div>
        </ng-container>
        <!-- Status resume -->
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'resume'">
          <div class="relative w-44 aspect-[8/5] bg-primary-50 rounded-lg flex items-center justify-center">
            <svg-icon src="@assets/images/icons/hourglass.svg" class="text-primary-500 w-5"></svg-icon>
          </div>
        </ng-container>
        <!-- Video completed -->
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'completed'">
          <div class="relative w-44 aspect-[8/5]">
            <span (click)="onSelectChange('replace')" class="z-10 w-6 h-6 rounded-full bg-slate-800 shadow-2xl flex items-center justify-center absolute -top-3 -right-3 cursor-pointer">
              <svg-icon src="@assets/images/icons/x-mark.svg" class="btn-icon text-slate-100"></svg-icon>
            </span>
            <div class="rounded-lg w-full h-full overflow-hidden absolute">
              <app-formly-videoplayer 
                [enableHotkey]="enableHotkey" 
                [sources$]="sources$" 
                [aspectRatio]="'8:5'">
              </app-formly-videoplayer>
            </div>
          </div>
        </ng-container>
        <!-- Loading -->
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'loading'">
          <div [thkLibProcessing]="vm.uploads![vm.lectureId!]?.status === 'loading'" class="flex w-44 aspect-[8/5] items-center justify-center max-sm:min-h-28"></div>
        </ng-container>

        <!-- Video info -->
        <div>
          <h3 class="text-slate-700 text-sm font-normal mb-2">{{props.videoInfo?.name}}</h3>
          <h4 class="text-slate-400 text-xs font-normal">{{props.videoInfo?.duration | formatDuration}}</h4>
        </div>

        <!-- uploader -->
        <uppy-drag-drop #dashboardUploader [uppy]="uppy" class="hidden h-[0] w-[0]"></uppy-drag-drop>
      </div>
      <!-- Upload -->
      <div *ngIf="vm.uploads![vm.lectureId!]?.status === 'completed' || vm.uploads![vm.lectureId!]?.status === 'init'" class="flex gap-3 mt-4">
        <select [ngModel]="selectedSize" (ngModelChange)="onSelectChange($event)" id="size-390" placeholder="Select" class="size-sm">
          <option [disabled]="true" selected="true" value="choose_action" i18n>Choose Action</option>
          <option value="upload_video" i18n>Upload Video</option>
          <option value="choose_from_your_library" i18n>Choose From Your Library</option>
        </select>
        <button *ngIf="vm.uploads![vm.lectureId!]?.status === 'completed'" type="button" (click)="onSelectChange('rollback')" class="btn btn-sm">
          <svg-icon src="@assets/images/icons/rollback.svg" class="btn-icon"></svg-icon>
          <span i18n>Rollback</span>
        </button>
      </div>
    </ng-container>

    <!-- Status upload-progress & uploading -->
    <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'upload-progress' || vm.uploads![vm.lectureId!]?.status === 'uploading'">
      <div class="flex items-center gap-2 px-3 py-1.5 rounded-md border border-slate-100 bg-slate-50 w-full mt-4">
        <svg-icon src="@assets/images/icons/cargo-ship.svg" class="btn-icon"></svg-icon>
        <p class="mb-0 text-xs text-slate-600 font-semibold" i18n>This video is currently being uploading. You can abort uploading by clicking here <span (click)="handleFileInfo('abort')" class="underline cursor-pointer font-semibold">Abort</span> .</p>
      </div>
    </ng-container>
    <!-- Status upload-complete -->
    <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'upload-complete'">
      <div class="flex items-center gap-2 px-3 py-1.5 rounded-md border border-green-100 bg-green-50 w-full mt-4">
        <svg-icon src="@assets/images/icons/cargo-ship.svg" class="btn-icon"></svg-icon>
        <p class="mb-0 text-xs text-green-600 font-semibold" i18n>File uploaded successfully done.</p>
      </div>
    </ng-container>
    <!-- Status processing -->
    <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'processing'">
      <div class="flex items-center gap-2 px-3 py-1.5 rounded-md border border-green-100 bg-green-50 w-full mt-4">
        <svg-icon src="@assets/images/icons/cargo-ship.svg" class="btn-icon"></svg-icon>
        <p class="mb-0 text-xs text-green-600 font-semibold" i18n>This video is currently being processed. You can play when it's complete.</p>
      </div>
    </ng-container>
    <!-- Status failed -->
    <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'failed'">
      <div class="flex items-center gap-2 px-3 py-1.5 rounded-md border border-red-100 bg-red-50 w-full mt-4">
        <svg-icon src="@assets/images/icons/cargo-ship.svg" class="btn-icon"></svg-icon>
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.error === 'video_processing_failed'">
          <p class="mb-0 text-xs text-red-600 font-semibold">
            {{ VIDEO_TRANSCODE_ERROR }} <span (click)="handleFileInfo('retry')" class="underline cursor-pointer font-semibold">Retry</span>
          </p>
        </ng-container>
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.error === 'video_has_no_audio'">
          <p class="mb-0 text-xs text-red-600 font-semibold">
            {{ SPEECH_TO_TEXT_ERROR }} <span (click)="handleFileInfo('retry')" class="underline cursor-pointer font-semibold">Retry</span>
          </p>
        </ng-container>
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.error === 'video_has_no_proper_image'">
          <p class="mb-0 text-xs text-red-600 font-semibold">
            {{ THUMBNAIL_ERROR }} <span (click)="handleFileInfo('retry')" class="underline cursor-pointer font-semibold">Retry</span>
          </p>
        </ng-container>
        <ng-container *ngIf="vm.uploads![vm.lectureId!]?.error === 'video_lecture_is_not_ready'">
          <p class="mb-0 text-xs text-red-600 font-semibold">
            {{ VIDEO_LECTURE_NOT_COMPLETED }} <span (click)="handleFileInfo('retry')" class="underline cursor-pointer font-semibold">Retry</span>
          </p>
        </ng-container>
      </div>
    </ng-container>
    <!-- Status resume -->
    <ng-container *ngIf="vm.uploads![vm.lectureId!]?.status === 'resume'">
      <div class="flex items-center gap-2 px-3 py-1.5 rounded-md border border-primary-100 bg-primary-50 w-full mt-4">
        <svg-icon src="@assets/images/icons/cargo-ship.svg" class="btn-icon"></svg-icon>
        <p class="mb-0 text-xs text-primary-600 font-semibold" i18n>Processing is pending and will begin shortly. Click <span (click)="handleFileInfo('retry')" class="underline cursor-pointer font-semibold">Resume</span> to speed it up.</p>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #default>
  <div class="uppyUpload">
    <div
      class="uppyUpload-default-container input-field items-center"
      type="file"
      *ngIf="!(state$ | async)?.viewState"
    >
      <uppy-drag-drop [uppy]="uppy" class="uppyUpload-default btn btn-sm p-0"></uppy-drag-drop>
    </div>
    <div class="uppyUpload-default-container input-field" type="file" *ngIf="(state$ | async)?.viewState">
      <formly-FileDefaultInfo
        [uploadState]="(state$ | async)!"
        (clickEvent)="handleFileInfo($event)"
        class="block w-full grow"
      ></formly-FileDefaultInfo>
    </div>
  </div>
</ng-template>

<!-- No Preview URL -->
<ng-template #noPreviewUI>
  <div *ngIf="props.previewResource === 'avatar'" class="bg-white flex h-full mx-auto rounded-full shadow h-[82px] w-[82px]">
    <img src="assets/images/image-placeholder.svg" class="m-auto h-11 w-11" alt="" defaultImage/>
  </div>
  <formly-imageplaceholder *ngIf="props.previewResource !== 'avatar'" text="Not Available"></formly-imageplaceholder>
</ng-template>